import { X } from "@phosphor-icons/react";
import { Button } from "@shopflo/ui/button";
import { Icon } from "@shopflo/ui/icon";
import { IconButton } from "@shopflo/ui/icon-button";

import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { usePopupOrchestrator } from "lib/contexts/PopupOrchestratorProvider";
import { useLocale } from "lib/hooks/useLocale";
import { HeaderCustomisations } from "lib/types/merchantConfigTypes";
import { eventTypes } from "lib/utils/constants";
import { publishPostMessage } from "lib/utils/helpers";

export type CartHeaderProps = {
  totalItems?: number;
  customisations?: HeaderCustomisations
  showBottomShadow?: boolean
};

export const CartHeader = ({ totalItems, customisations, showBottomShadow = false }: CartHeaderProps) => {
  const { t } = useLocale();
  const {
    actions: { setCheckoutModal },
  } = useCheckoutContext();
  const { closePopup } = usePopupOrchestrator();
  return (
    <div className="flex w-full items-center justify-between pl-5 pr-4 h-[44px] relative z-10"
      style={{
        backgroundColor: customisations?.backgroundColor,
        boxShadow: showBottomShadow ? '0px 1px 5px 0px rgba(175, 175, 175, 0.3)' : 'none',
      }}
    >
      <div className="flex h-6 items-center gap-2 font-medium text-coal-dark">
        <div className="flex gap-1 items-center"
          style={{
            color: customisations?.textColor,
          }}
        >
          <span className="text-eyebrow-xs">{t("your_cart").toUpperCase()}</span>
          {Boolean(totalItems) && (
            <>
              <span className="font-normal text-coal-light text-text-xs-medium text-inherit"
              >{`(${totalItems})`}</span>
            </>
          )}
        </div>
      </div>
      <IconButton
        variant="ghost"
        size="sm"
        IconComponent={X}
        iconProps={{
          color: customisations?.textColor,
        }}
        onClick={() => {
          setCheckoutModal("NONE");
          closePopup();
          publishPostMessage(eventTypes.CLOSE_CART_IFRAME, {});
        }}
      />
    </div>
  );
};
